import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import {
	type CustomPlacementProps,
	PlacementFrontend,
} from '@post-office/browser--jira-tanuki/jira-software-currency-field-recommendations';

import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';

import { useCallback } from 'react';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

// This is the Message Frontend. In this Placement we have render.Component which takes a React Component which will render your message in the Placement.
export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<CustomPlacementProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<CustomPlacementProps>(),
		Component: ({ children, dismiss }) => {
			const { onClosed } = usePostOfficeUserInteractions();
			// Create a basic callback that hooks into Post Office's dismissal flow.
			// Vital to ensure a dismissed message is marked as dismissed in
			// Post Office and never seen again.
			const handleDismiss = useCallback(() => {
				dismiss();
				void onClosed({ interactionIdentifier: 'dismiss' });
			}, [onClosed, dismiss]);
			return <>{children(handleDismiss)}</>;
		},
	},
});
